<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-btn flat icon color="green">
              <v-icon @click.native="doExit">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title>View Policy Transaction</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark small color="error" v-on="on" @click="promptDelete = true">
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-toolbar>
          <confirm v-model="promptDelete" @ok="doDelete">{{ deleteMessage }}</confirm>
          <QueryPolicyBody :functionId="'deleteUnReleasePolicy'"></QueryPolicyBody>
        </v-flex>
      </v-layout>
    </v-container>

    <warning v-model="warnMsg" @ok="doAcceptWarnMsg" @cancel="warnMsg = false">{{ warningMsg }}</warning>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px" >
      <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-information</v-icon>
        <v-toolbar-title>System Information</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div v-if="messages.length > 0" class="pb-3">
        <v-subheader>Oops something went wrong:</v-subheader>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in messages" :key="index">
          {{error.message}}
          </li>
        </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import QueryPolicyBody from '../policy/query/QueryPolicyBody'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data () {
    return {
      promptDelete: undefined,
      deleteMessage: 'This record will be deleted. (84)',
      loading: false,
      showErrorDialog: false,
      warnMsg: false,
      warningMsg: undefined
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    async doDelete() {
      const apiUrl = this.$store.state.underwriting.deletePolicySettings.menu.deleteUnreleasedPolicy
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }

          const result = await this.$http.post(expandURI(apiUrl, expand))
          if (result.data) {
            if (result.data.messages) {
              this.warningMsg = result.data.messages[0].message
              this.warnMsg = true
            } else {
              this.$toast.success('Policy Deleted Successfuly.')
              this.doExit()
            }
          }

          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAcceptWarnMsg() {
      const apiUrl = this.$store.state.underwriting.deletePolicySettings.menu.proceedDeleteUnreleasedPolicy
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }

          const result = await this.$http.post(expandURI(apiUrl, expand))

          if (result.data) {
            this.$toast.success('Policy Deleted Successfuly.')
            this.doExit()
          }

          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.deletePolicySettings.init !== 1) {
      this.$store.dispatch('deletePolicyInit')
    }
  },
  components: {
    QueryPolicyBody
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
